import React, { useEffect, useState } from 'react';
import Blog from '../../../components/insights/blog/Blog.component';
import { loaderArray } from '../../../constant';
import TileLoader from '../../../components/shared/TileLoader';
import { gTag } from '../../../helpers';
import { capitalize } from 'lodash';

/**
 * @description This component render the list of lessons
 * @param {object} $lessons - {done, percent, seconds, when}
 * @param {boolean} $loading - true/false
 */
const InsightPodcast = ({ blogs, loading, setAttention }) => {
  const [show, showHide] = useState({});
  const [showAll, setShowAll] = useState(null);

  const toggleShowClose = (blogs, status) =>
    Object.keys(blogs).reduce((prevValue, currValue) => {
      return {
        ...prevValue,
        [currValue]: status,
      };
    }, {});

  useEffect(() => {
    let show = localStorage.getItem('show') && JSON.parse(localStorage.getItem('show'));
    let showAll = localStorage.getItem('showAll') && JSON.parse(localStorage.getItem('showAll'));
    showAll && setShowAll(showAll);
    show && showHide(show);
    if (showAll) {
      showHide(toggleShowClose(blogs, true));
    } else if (show && !showAll) {
      showHide(show);
    } else if (!showAll) {
      showHide(toggleShowClose(blogs, false));
    }
  }, [blogs]);

  const handleShowHide = (item) => {
    let BlogTypes;
    show ? (BlogTypes = { ...show, [item]: !show[item] }) : (BlogTypes = { [item]: !show[item] });
    showHide(BlogTypes);
    localStorage.setItem('show', JSON.stringify(BlogTypes));
  };

  const showHideAll = () => {
    setShowAll(!showAll);
    localStorage.setItem('showAll', JSON.stringify(!showAll));
    showHide(toggleShowClose(blogs, !showAll));
    !!showAll && localStorage.removeItem('show');
  };
  const filteredPodcasts = {};
  const filteredArray = Object.values(blogs).filter((blogs) => blogs[0].type === 'podcast');
  for (let keys in blogs) {
    if (filteredArray.includes(blogs[keys]) && keys !== 'null') {
      filteredPodcasts[keys] = blogs[keys];
    }
  }
  return (
    <div>
      <header className="intro">
        {window.location.hash === '#/assets/podcasts' ? (
          <p>Business Development Resources</p>
        ) : (
          <p>
            These short video Lessons answer critical questions about how to develop business. Watch them in sequence or
            skip ahead to topics of interest.
          </p>
        )}
      </header>
      <ol className="ai-dashboard lesson-container" id="trainer-list">
        <li className="break collapsible" onClick={showHideAll}>
          <h2 className="open-close-all">
            <label>
              <span>{showAll ? 'Close All' : 'Open All'}</span>
              <span className="caret-wrapper">
                <span className="caret" />
              </span>
            </label>
          </h2>
        </li>
        {loading
          ? loaderArray.map((i) => (
              <li key={i}>
                <TileLoader />
              </li>
            ))
          : Object.keys(filteredPodcasts).map((item, index) => {
              const description = blogs[item][0].category_description || '';
              return (
                <React.Fragment key={index}>
                  <li
                    className="break collapsible"
                    onClick={() => {
                      handleShowHide(item);
                      gTag(`Lesson Category: ${capitalize(item)}`, !show[item] ? 'Expanded' : 'Collapsed');
                    }}
                  >
                    <h2>
                      <label>
                        <span>{item}</span>
                        <span className="caret-wrapper">
                          <span className="caret" />
                        </span>
                      </label>
                    </h2>
                    <div className="description">{description}</div>
                  </li>
                  {show[item] &&
                    blogs[item].map((blog) => <Blog key={blog.id} {...blog} setAttention={setAttention} />)}
                </React.Fragment>
              );
            })}
      </ol>
    </div>
  );
};

export default InsightPodcast;
